module.exports = {
      id: "share-usage",
      viewBox: "0 0 13 13",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#share",
      toString: function () {
        return this.url;
      }
    }